export const NAVIGATOR_LANGUAGE = /^fr\b/.test(navigator.language) ? 'fr' : 'en';
export const BACKUP_LOCALE = NAVIGATOR_LANGUAGE === 'fr' ? 'fr-FR' : 'en-GB';
